module.exports = __webpack_public_path__ + "img/GroupN4.f7d07ba7.png";